// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#page-container[data-v-3f658fd8]{height:100%}", ""]);
// Exports
module.exports = exports;
